import { render, staticRenderFns } from "./defaultLanguageSelect.vue?vue&type=template&id=7db439e9"
import script from "./defaultLanguageSelect.vue?vue&type=script&lang=js"
export * from "./defaultLanguageSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports